import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import CacheManager from '../../../cache/CacheManager';
import AddPhoneModalUI from './AddPhoneModalUI';

class AddPhoneModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      phone: '',
      phoneError: null,
    };
  }

  render() {
    return (
      <AddPhoneModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // Event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onAddPhoneCancel}
        // Modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // Form fields
        phone={this.state.phone}
        onPhoneChange={(event) => this.setState({ phone: event.target.value })}
        phoneError={this.state.phoneError}
        setphoneError={(error) => this.setState({ phoneError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    if (!prevProps) return;
    
    const currentMessageId = this.props.message && this.props.message.messageApprovalId;
    const prevMessageId = prevProps.message && prevProps.message.messageApprovalId;
    
    if (!currentMessageId) return;
    
    if (prevMessageId !== currentMessageId) {
      this.setState({ phone: '' });
    }
  }

  onAddPhoneCancel = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false,
      phone: '',
      phoneError: null,
    });

    if (this.props.onAddEmailCancel) {
      this.props.onAddEmailCancel();
    } else if (this.props.onAddPhoneCancel) {
      this.props.onAddPhoneCancel();
    }
  }

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    try {
      const messageApprovalId = this.props.message && this.props.message.messageApprovalId;
      if (!messageApprovalId) {
        throw new Error('Message approval ID is required');
      }

      if (!this.state.phone || this.state.phone.trim() === '') {
        throw new Error('Phone number is required');
      }

      const phoneNumbersStr = localStorage.getItem('phoneNumbers');
      const phoneNumbersMap = phoneNumbersStr ? JSON.parse(phoneNumbersStr) : {};
      
      const messagePhones = phoneNumbersMap[messageApprovalId] || [];
      
      if (messagePhones.includes(this.state.phone)) {
        throw new Error('This phone number already exists in the recipient list');
      }
    
      messagePhones.push(this.state.phone);
      
      phoneNumbersMap[messageApprovalId] = messagePhones;
      
      CacheManager.setObject('phoneNumbers', phoneNumbersMap);
      
      this.setState({
        successMsg: 'Phone number added successfully',
        submitted: false,
      });

      setTimeout(() => {
        this.setState({ 
          successMsg: null,
          phone: '' 
        });
        
        if (this.props.onAddEmailCancel) {
          this.props.onAddEmailCancel();
        } else if (this.props.onAddPhoneCancel) {
          this.props.onAddPhoneCancel();
        }
        
        if (this.props.onRefreshClick) {
          this.props.onRefreshClick();
        }
      }, 2000);
    } catch (error) {
      this.setState({
        errorList: [error.message || 'Failed to save phone number'],
        submitted: false,
      });
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList });
  };
}

export default withRouter(AddPhoneModalSF);